<div class="snippet">
  <div class="stage">
    <div class="dot-falling"></div>
  </div>
</div>
